import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-jia",
  "use": "icon-icon-jia-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-jia\">\n    <title>jia备份 3</title>\n    <g id=\"icon-icon-jia_金融产品\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-357.000000, -386.000000)\" fill-rule=\"nonzero\" id=\"icon-icon-jia_jia备份-3\">\n            <g transform=\"translate(357.394395, 386.486486)\">\n                <rect id=\"icon-icon-jia_矩形\" fill=\"#000000\" opacity=\"0\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" />\n                <polygon id=\"icon-icon-jia_路径\" fill=\"#999999\" points=\"19 13 13 13 13 19 11 19 11 13 4.99999999 13 4.99999999 11 11 11 11 4.99999999 13 4.99999999 13 11 19 11 19 13\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-jia.svg
// module id = d5eA
// module chunks = 3